type NestedMetrics = Record<string, Record<string, number>>;

export default class AnalyticsModel  {
    generalBySourceUuid: NestedMetrics;
    ordersCountByCreatedDateAndSourceUuid: NestedMetrics;
    ordersSumByCreatedDateAndSourceUuid: NestedMetrics;
    ordersProfitSumByCreatedDateAndStatusType: NestedMetrics;
    ordersProfitSumByClosedDateAndStatusType: NestedMetrics;

    constructor(
        general_by_source_uuid: NestedMetrics,
        orders_count_by_created_date_and_source_uuid: NestedMetrics,
        orders_sum_by_created_date_and_source_uuid: NestedMetrics,
        orders_profit_sum_by_created_date_and_status_type: NestedMetrics,
        orders_profit_sum_by_closed_date_and_status_type: NestedMetrics,
    ) {
        this.generalBySourceUuid = general_by_source_uuid || {};
        this.ordersCountByCreatedDateAndSourceUuid = orders_count_by_created_date_and_source_uuid || {};
        this.ordersSumByCreatedDateAndSourceUuid = orders_sum_by_created_date_and_source_uuid || {};
        this.ordersProfitSumByCreatedDateAndStatusType = orders_profit_sum_by_created_date_and_status_type || {};
        this.ordersProfitSumByClosedDateAndStatusType = orders_profit_sum_by_closed_date_and_status_type || {};
    }
}